import { TexturesIcon } from 'src/components/widgets/icons/scene';
import React, { FC, useState } from 'react';
import { T } from 'src/shared/helpers';
import { DuplicateIcon, PlusIcon, RenameIcon, TrashIcon, ViewGridIcon, ViewListIcon } from '../../../../../widgets/icons/scene';
import { ResourceListViewMode, ResourceListViewModeSwitch } from '../../../../../widgets/resourceList';
import { AssetEmptyState, AssetGrid } from './assetLibraryPanel';
import SectionPanel from './sectionPanel';
import { SceneEditorAction } from './sceneEditorActionBar';

// L'INVOLUCRO, NON IL CONTENUTO (utente, 2026-08-12). La libreria delle texture ha la stessa
// forma di quella dei materiali — comandi, ricerca, filtro, tessere — meno il raggruppamento,
// che è dei materiali soltanto.
//
// Dentro non c'è niente, e non è una svista: **una texture non è un'entità di questo
// backoffice**. Le immagini esistono attaccate ai canali di un materiale (`albedoTexture`,
// `bumpTexture`, …) e nessun metodo le raccoglie in un elenco con nome, formato, risoluzione
// e spazio colore — che è ciò che la tessera del prototipo mostra
// (docs/scene-editor-new-sections.md § 1). Il giorno che quel raccoglitore esiste, qui
// cambia solo cosa si passa alla griglia.

const TexturesEditor: FC = () => {
    const [viewMode, setViewMode] = useState<ResourceListViewMode>('cards');
    const [filter, setFilter] = useState('');

    // I comandi ci sono e sono spenti: la barra nasce con i posti al punto giusto, così un
    // comando che arriva si aggiunge invece di far riprogettare la riga.
    const actions: SceneEditorAction[] = [
        {
            name: T._('Add texture', 'Admin'),
            tooltip: T._('Add a texture to the library', 'Admin'),
            icon: <PlusIcon />,
            kind: 'add',
            disabled: true,
            onClick: () => {}
        },
        { name: T._('Clone', 'Admin'), tooltip: T._('Clone', 'Admin'), icon: <DuplicateIcon />, disabled: true, onClick: () => {} },
        { name: T._('Rename', 'Admin'), tooltip: T._('Rename', 'Admin'), icon: <RenameIcon />, disabled: true, onClick: () => {} },
        { name: T._('Delete', 'Admin'), tooltip: T._('Delete', 'Admin'), icon: <TrashIcon />, kind: 'danger', disabled: true, onClick: () => {} }
    ];

    return (
        <SectionPanel
            label={T._('Textures library', 'Admin')}
            actions={actions}
            searchTrailing={
                <ResourceListViewModeSwitch
                    viewMode={viewMode}
                    viewModeLabel={T._('Textures view', 'Admin')}
                    cardsViewLabel={T._('Grid view', 'Admin')}
                    tableViewLabel={T._('List view', 'Admin')}
                    cardsIcon={<ViewGridIcon />}
                    tableIcon={<ViewListIcon />}
                    onViewModeChange={setViewMode}
                    tableFirst
                />
            }
            filter={filter}
            onFilterChange={setFilter}
            showUsageFilter
            searchPlaceholder={T._('Search textures…', 'Admin')}
        >
            <AssetGrid $list={viewMode === 'table'} />
            <AssetEmptyState icon={<TexturesIcon />}>
                {T._('Textures are not collected yet: they live inside the materials that use them.', 'Admin')}
            </AssetEmptyState>
        </SectionPanel>
    );
};

export default TexturesEditor;
